import produce from "immer";

import { UseOfName } from "../../../interfaces/enum";
import { ModelState } from "../../../interfaces/modelState";

interface PersonalDataMutationModel {
  oldName: string;
  salutation: string;
  initials: string;
  firstName: string;
  inserts: string;
  lastName: string;
  partnerInserts: string;
  partnerLastName: string;
  useOfName?: UseOfName;
  usePartnerName: boolean;
}

interface State {
  data: Partial<PersonalDataMutationModel>;
  loading: boolean;
  modelState: ModelState | null;
}

export const initialState: State = {
  data: {
    oldName: undefined,
    salutation: undefined,
    initials: undefined,
    firstName: undefined,
    inserts: undefined,
    lastName: undefined,
    partnerInserts: undefined,
    partnerLastName: undefined,
    useOfName: undefined,
    usePartnerName: false,
  },
  loading: false,
  modelState: null,
};

type Action =
  | { type: "UPDATE_PERSONAL_DATA_MUTATION_DATA"; payload: Partial<PersonalDataMutationModel> }
  | { type: "UPDATE_PERSONAL_DATA_MUTATION_ERROR"; payload: ModelState }
  | { type: "UPDATE_PERSONAL_DATA_MUTATION_FETCH_START" }
  | { type: "UPDATE_PERSONAL_DATA_MUTATION_FETCH_ERROR"; payload: ModelState };

export const personalDataMutationReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "UPDATE_PERSONAL_DATA_MUTATION_DATA":
      return produce(state, (draft) => {
        draft.data = { ...draft.data, ...action.payload };
      });
    case "UPDATE_PERSONAL_DATA_MUTATION_ERROR":
      return produce(state, (draft) => {
        draft.modelState = action.payload;
      });
    case "UPDATE_PERSONAL_DATA_MUTATION_FETCH_START":
      return produce(state, (draft) => {
        draft.loading = true;
      });
    case "UPDATE_PERSONAL_DATA_MUTATION_FETCH_ERROR":
      return produce(state, (draft) => {
        draft.loading = false;
        draft.modelState = action.payload;
      });
  }
};
